var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M395 320.089V74.911L258.806 197.5zM197.5 252.682l-38.884-35L22.421 340.271h350.158L236.384 217.682zM372.579 54.729H22.421L197.5 212.318zM0 74.911v245.178L136.194 197.5z"}));
}

Mail.defaultProps = {"viewBox":"0 0 395 395"};

module.exports = Mail;

Mail.default = Mail;
